import { render } from "./CustomerContextSelect.vue?vue&type=template&id=f4edbfe2"
import script from "./CustomerContextSelect.vue?vue&type=script&lang=js"
export * from "./CustomerContextSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__